import React from 'react';
import { Account } from 'types/Customer';
import { CheckIcon } from '@heroicons/react/24/outline';

interface AccountProps {
  account: Account
  onClick: () => void;
  selected: boolean;
}

const AccountItem: React.FC<AccountProps> = ({ account, onClick, selected }) => {
  return (
    <div className="relative mr-4">
      {selected && (
        <div className="absolute top-0 right-0 transform translate-x-1/3 -translate-y-1/3">
          <div className="bg-green-500 rounded-full p-1 h-5 w-5">
            <CheckIcon className="h-3 w-3 text-white" />
          </div>
        </div>
      )}
        <button type="button" className="flex w-full flex-col items-start justify-center rounded-lg bg-white p-4 text-left shadow" onClick={onClick}>
          <span className="text-lg font-semibold text-gray-800">{account.number}</span>
          <span className="text-sm text-gray-600">{account.name}</span>
        </button>
    </div>
  );
};

export default AccountItem;